import { GLOSSARY, GLOSSARY_BY_KEY } from "../data/glossary";
import type { GlossaryEntry, GlossaryEntryTerm } from "../types";

export function getGlossaries(
  keys?: GlossaryEntryTerm | GlossaryEntryTerm[],
): GlossaryEntry[] {
  if (!keys) {
    return GLOSSARY;
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list.map(key => GLOSSARY_BY_KEY[key]).filter(Boolean);
}

export function getGlossaryByKey(key: GlossaryEntryTerm): GlossaryEntry {
  return GLOSSARY_BY_KEY[key];
}
